import React from 'react';
import { Drawer } from 'antd';
import { useNavigate } from 'react-router-dom';
import { NavMenu, NavBrand } from './NavSide';
import { SIDER_WIDTH } from '@theme/constants';
import './sider.css';

/**
 * The sidebar below 992px.
 *
 * Same menu as the desktop rail, presented as a slide-over so the
 * content column keeps its full width instead of being squeezed by a
 * 72px icon strip. Closes itself on navigate.
 */
const MobileNavDrawer = ({ open, onClose }) => {
  const navigate = useNavigate();

  return (
    <Drawer
      open={ open }
      onClose={ onClose }
      placement="left"
      width={ SIDER_WIDTH }
      closable={ false }
      className="nav-drawer"
      styles={ { body: { padding: 0 } } }
    >
      <NavBrand onClick={ () => { navigate('/'); onClose(); } } />
      <div className="nav-scroll">
        <NavMenu onNavigate={ onClose } />
      </div>
    </Drawer>
  );
};

export default MobileNavDrawer;
